<template>
  <label class="block text-sm font-medium text-grey-90 poppins">
    <slot />
    <span v-if="optional" class="italic text-gray-500 text-xs">({{ $t('common.fields.optional') }})</span>
  </label>
</template>

<script>
export default {
  props: {
    optional: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
